// import * as types from '../constants/ActionTypes'

import {login, logout, getUserInfo, isAdmin} from './auth';

export {login, logout, getUserInfo, isAdmin};



// WEBPACK FOOTER //
// ./actions/index.js